import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarCheck, X, ArrowRight } from "lucide-react";

export default function MonthReadyBanner({ ym, count, onOpen }) {
  const { t, i18n } = useTranslation();
  const storeKey = `pms-month-review-dismissed-${ym}`;
  const [hidden, setHidden] = useState(() => localStorage.getItem(storeKey) === "1");
  if (hidden || new Date().getDate() > 7 || !count) return null;
  const month = new Intl.DateTimeFormat(i18n.language || "en", { month: "long" }).format(new Date(Number(ym.slice(0, 4)), Number(ym.slice(5, 7)) - 1, 1));
  return (
    <div data-testid="month-review-banner" className="relative overflow-hidden rounded-2xl bg-slate-950 text-white p-5 flex flex-wrap items-center gap-4">
      <div className="absolute -top-16 -right-10 h-48 w-48 rounded-full bg-amber-500/20 blur-3xl" />
      <div className="relative w-10 h-10 rounded-xl bg-amber-500/15 text-amber-400 flex items-center justify-center"><CalendarCheck size={18} /></div>
      <div className="relative min-w-0 flex-1">
        <div className="font-display font-bold text-lg tracking-tight first-letter:uppercase">{t("insights.review.bannerTitle", { month })}</div>
        <p className="text-xs text-slate-400">{t("insights.review.bannerBody", { count })}</p>
      </div>
      <button type="button" data-testid="month-review-banner-open" onClick={onOpen}
        className="relative inline-flex items-center gap-1.5 h-9 px-4 rounded-lg bg-amber-500 text-slate-950 text-sm font-semibold hover:bg-amber-400 transition-colors">
        {t("insights.review.bannerCta")} <ArrowRight size={14} />
      </button>
      <button type="button" data-testid="month-review-banner-dismiss" aria-label="Dismiss" onClick={() => { localStorage.setItem(storeKey, "1"); setHidden(true); }}
        className="relative h-8 w-8 inline-flex items-center justify-center rounded-lg text-slate-400 hover:text-white hover:bg-white/10">
        <X size={14} />
      </button>
    </div>
  );
}
